import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationReadStatus } from '../status/NotificationReadStatus';
import { NotificationFolderWatcherType } from '../../../notification.types';
import {
  sendNotificationClickedEvent,
  getNotificationTrackingParameters,
} from '../../../notificationUtils';
import { StateType } from '../../../../../state/reducers';
import { NotificationWatcherQuery } from '../../query/NotificationWatcherQuery';
import { NotificationWatcherTitle } from '../../title/NotificationWatcherTitle';
import { NotificationLink } from '../../link/NotificationLink';
import { NotificationLinkContent } from '../../link/NotificationLinkContent';
import { NotificationLinkDate } from '../../link/NotificationLinkDate';

type Props = {
  notification: NotificationFolderWatcherType;
  notificationClicked: Function;
};

export const NotificationFolderWatcher: FC<Props> = ({
  notification,
  notificationClicked,
}) => {
  const { isAlreadyRead } = useSelector(({ notifications }: StateType) => ({
    isAlreadyRead: !!notifications.notifReadStatusMap[notification.id],
  }));

  const onNotificationClicked = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    sendNotificationClickedEvent();
    notificationClicked(notification)(event);
  };

  const { folderWatcher } = notification.data;
  return (
    <NotificationLink
      href={buildUrlWithParameters(
        notification.link,
        getNotificationTrackingParameters(notification),
      )}
      onClick={onNotificationClicked}
    >
      <NotificationReadStatus notificationId={notification.id} />
      <NotificationLinkContent>
        <NotificationWatcherQuery isAlreadyRead={isAlreadyRead}>
          {folderWatcher.folderTitle}
        </NotificationWatcherQuery>
        <NotificationWatcherTitle>
          {folderWatcher.title}
        </NotificationWatcherTitle>
        <NotificationLinkDate>
          {formatShortDateFromNow(notification.date)}
        </NotificationLinkDate>
      </NotificationLinkContent>
    </NotificationLink>
  );
};
